import React, { useEffect, useState } from 'react';
// import "./styles.scss";
import SparePartUploader from 'Components/SparePartUploader';
import { useDispatch } from 'react-redux';
import { getSpareParts } from '../../Redux/Slices/Accessor/accessorSlice';
import {
    addSparePartEntry,
    clearAllSparePartEntries,
    updateSparePartField
} from '../../Redux/Slices/Accessor/sparePartUploaderSlice';
import { useLocation } from 'react-router-dom';


const ApproveSparePartsDetails = ({ assessment_id }) => {
    const [productName, setproductName] = useState("");
    const [ImageFile, setImageFile] = useState(null);
    const [uploadError, setUploadError] = useState("");
    const dispatch = useDispatch();



    useEffect(() => {
        //   if (issparepartNameImageCategory) {
        dispatch(getSpareParts({
            assessment_id: assessment_id,
            callBack: (data) => {
                // Clear existing entries first
                dispatch(clearAllSparePartEntries());

                // Transform the API data to match the component's expected format
                if (data && data.length > 0) {
                    data.forEach(item => {
                        dispatch(addSparePartEntry());
                        const index = data.indexOf(item);

                        // Update each field for the spare part entry
                        dispatch(updateSparePartField({
                            index,
                            field: "product_name",
                            value: item.product_name || ""
                        }));

                        dispatch(updateSparePartField({
                            index,
                            field: "photos",
                            value: item.photos || []
                        }));

                        dispatch(updateSparePartField({
                            index,
                            field: "backlog_id",
                            value: item.backlog_id
                        }));

                        // Store the log_id for potential updates/deletes
                        dispatch(updateSparePartField({
                            index,
                            field: "log_id",
                            value: item.log_id
                        }));
                    });
                } else {
                    // If no data, add one empty entry
                    dispatch(addSparePartEntry());
                }
            }
        }));
        //   }
    }, [dispatch]);
    return (
        <div>
            <SparePartUploader
                isEditable={false}
                name={productName}
                setName={setproductName}
                image={ImageFile}
                setImage={setImageFile}
                uploadError={uploadError}
                setUploadError={setUploadError}
                isLoading={false}
            />
        </div>
    )
}

export default ApproveSparePartsDetails;

